function showLimitFun(el, binding) {
    setTimeout(() => {
        let tagWrap = el.querySelector(".el-select__tags>span");
        // 溢出隐藏
        for( let i=0; i<tagWrap.children.length; i++ ){
            if( (i+1) > binding.value ){
                tagWrap.children[i].style.display = "none";
            }else{
                tagWrap.children[i].style.display = "flex";
            }
        }
        // 改tag显示隐藏
        let selShowLimitTip = el.querySelector(".selShowLimitTip");
        if( tagWrap.children.length > binding.value ){
            selShowLimitTip.style.display = "inline-block";
            selShowLimitTip.style["line-height"] = "18px";
            selShowLimitTip.style.border = "solid 1px #dcdfe6";
            selShowLimitTip.style.background = "#f4f4f5";
        }else{
            selShowLimitTip.style.display = "none";
        }
        let sec = el.querySelector("section");
        sec.style = "";
        // 改tag内容
        selShowLimitTip.innerHTML = `+ ${( tagWrap.children.length - binding.value )}`;
        // 改高度
        let ipt = el.querySelector(".el-input__inner");
        let c = tagWrap.children.length > binding.value ? binding.value : tagWrap.children.length;
        ipt.style.height = ( 30 * c ) + ( 28 ) + "px";
    }, 50);
}

export default {
    inserted: function(el, binding) {
        let tagWrap = el.querySelector(".el-select__tags>span");
        // 添加tag
        tagWrap.insertAdjacentHTML("afterend", `<span class="selShowLimitTip" 
      style="
      display: inline-block;
      line-height:28px;
      margin-left:6px;
      background-color:#F0F2F5;
      color:#909399;
      border-radius:4px;
      padding:0px 5px 0px 9px;
      font-size:14px;
      "
    ></span>`);
        tagWrap.insertAdjacentHTML("afterend","<section style='width:100%'></section>");
        showLimitFun(el, binding);
    },
    update: showLimitFun
}
